import axios from 'axios';
import { getApiBaseUrl } from '../config';

const getAuthHeader = () => {
    const token = localStorage.getItem('parentToken');
    return token ? { Authorization: `Bearer ${token}` } : {};
};

export const paymentService = {
    getAdmissionFeeCategory: async (academicSessionId, classId, paymentCycle = "Monthly") => {
        const response = await axios.get(`${getApiBaseUrl()}/class-fee-categories/admission/${academicSessionId}/${classId}`, {
            params: { paymentCycle },
            headers: getAuthHeader()
        });
        return response.data;
    },

    getFeeCategory: async () => {
        const response = await axios.get(`${getApiBaseUrl()}/class-fee-categories?paymentType=Monthly`, {
            headers: getAuthHeader()
        });
        return response.data;
    },

    getScholarships: async (enrollmentId, academicSessionId) => {
        const response = await axios.get(`${getApiBaseUrl()}/scholarships/enrollment`, {
            params: { enrollmentId, academicSessionId },
            headers: getAuthHeader()
        });
        return response.data;
    },

    getPaymentHistory: async (enrollmentId, academicSessionId) => {
        const response = await axios.get(`${getApiBaseUrl()}/payments/enrollment/${enrollmentId}`, {
            params: { academicSessionId },
            headers: getAuthHeader()
        });
        return response.data;
    },

    getOneTimePayments: async (enrollmentId, status) => {
        const response = await axios.get(`${getApiBaseUrl()}/payment-requests/enrollment/${enrollmentId}`, {
            params: { status },
            headers: getAuthHeader()
        });
        return response.data;
    },

    getReceiptData: async (paymentId) => {
        const response = await axios.get(`${getApiBaseUrl()}/payments/${paymentId}/receipt-data`, {
            headers: getAuthHeader()
        });
        return response.data;
    },

    initiatePayment: async (paymentData) => {
        const response = await axios.post(`${getApiBaseUrl()}/payments/initiate`, paymentData, {
            headers: getAuthHeader()
        });
        return response.data;
    },

    queryPaymentStatus: async (transactionId, type = "merchant") => {
        const response = await axios.get(`${getApiBaseUrl()}/payments/status`, {
            params: { transactionId, type },
            headers: getAuthHeader()
        });
        return response.data;
    }
};
